import React, { useState } from "react";
import { Table } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import CategoryEdit from "./CategoryEdit";
import CategoryAdd from "./CategoryAdd";
import DeleteModal from "../DeleteModal";
import { requestHandler } from "../../helper";
import { updateCategory } from "../../controller";
import { toast } from "react-toastify";

function CategoryTable({ categoryData, page, perPage, searchQuery, getCategoryData, setPage, handleSearchChange, onStatusChange, status }) {

    const [selectedStatus, setSelectedStatus] = useState('all');
    const onSuccessData = () => {
        if (categoryData.length === 1 && page > 1) {
            setPage(page - 1)
        } else {
            getCategoryData(perPage, page, searchQuery)
        }
    }

    const handleEditCat = async (updatedData, itemId) => {
        await requestHandler(
            () => updateCategory(updatedData, itemId),  // Only pass the updated field
            null,
            (res) => {
                toast.success(res.message);
                onSuccessData();  // Handle success
            },
            () => { }  // Handle error (optional)
        );
    };


    const handleStatusSelect = (newStatus) => {
        // onStatusChange(newStatus); // Convert string to boolean
        setSelectedStatus(newStatus); // Update the selected status
        onStatusChange(newStatus === 'all' ? '' : newStatus);
    };

    return (
        <>
            <div className="card-header border-0 p-0 pb-3">
                <div className="row">
                    <div className="col-12 col-lg-5 col-xl-4">
                        <div className="form-control search-bar py-0 px-0">
                            <div className="search-box">
                                <img
                                    src="./images/png/seach-icon.png"
                                    width={13.81}
                                    height={13.81}
                                    alt=""
                                />
                            </div>
                            <input
                                type="text"
                                className="form-control rounded-start-0 border-0"
                                placeholder="Search here"
                                value={searchQuery} onChange={handleSearchChange}
                            />
                        </div>
                    </div>

                    <div className="col-12 col-lg-7 col-xl-8 mt-3 mt-lg-0">
                        <div className="d-flex flex-wrap justify-content-end align-items-center gap-3">
                            <Dropdown className="status-btn">
                                <Dropdown.Toggle
                                    variant="success"
                                    id="dropdown-basic"
                                    className={status ? '' : 'text_light'}
                                >
                                    {status === '' ? 'Status' : status === 'true' ? 'Active' : 'Deactive'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleStatusSelect('all')} className={selectedStatus === 'all' ? 'selected-status' : ''}>All</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleStatusSelect('true')} className={selectedStatus === 'true' ? 'selected-status' : ''}>Active</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleStatusSelect('false')} className={selectedStatus === 'false' ? 'selected-status' : ''}>Deactive</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <CategoryAdd getCategoryData={getCategoryData} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="overflow-auto-lg">
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>
                                No{" "}

                            </th>
                            <th>
                                Category Name{" "}

                            </th>
                            <th className="text-center">Status</th>
                            <th
                                style={{ width: "180px" }}
                                className="text-center"
                            >
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {categoryData.length > 0 ? (
                            categoryData.map((item, index) => (
                                <tr key={index}>
                                    <td>{(page - 1) * perPage + index + 1}</td>
                                    <td className="text_primary">
                                        {item.name}
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-center">
                                            <Dropdown className="status-btn active">
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {item.status ? 'Active' : 'Deactive'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => handleEditCat({ name: item.name, status: true }, item._id)}
                                                        className={item.status === true ? 'selected-status' : ''}
                                                    >Active</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleEditCat({ name: item.name, status: false }, item._id)}
                                                        className={item.status === false ? 'selected-status' : ''}
                                                    >Deactive</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </td>
                                    <td style={{ width: "180px" }}>
                                        <div className="d-flex justify-content-center align-items-center gap-2 actions-image">
                                            {/* Example: Add actions as needed */}
                                            <CategoryEdit id={item._id} categoryData={categoryData} getCategoryData={getCategoryData} />
                                            <DeleteModal title={"Category Details"} id={item._id} endPoint={`/category/delete`} onSuccess={onSuccessData} />
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={7} className='text-center py-3'>
                                    No data available
                                </td>
                            </tr>
                        )
                        }
                    </tbody>
                </Table>

            </div>
        </>
    );
}

export default CategoryTable;
